<template>
  <v-list-item @click="logout">
    <v-list-item-icon class="mr-3">
      <v-icon>$logout</v-icon>
    </v-list-item-icon>
    <v-list-item-title>{{ $t("logOut") }}</v-list-item-title>
  </v-list-item>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "LogOut",
  methods: {
    logout() {
      this.$router.push("/login");
      this.clearSession();
    },
    ...mapActions(["clearSession"]),
  },
};
</script>
